module.exports = __webpack_public_path__ + "static/soc1-a6d0a1d1c8799be6420fa6e39ac99bd7.png";